import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import * as moment from 'moment';

@Component({
    selector: 'app-time-list-element',
    templateUrl: './time-list-element.component.html',
    styleUrls: ['./time-list-element.component.scss'],
})
export class TimeListElementComponent implements OnInit {
    @Input() public dateTime: string;
    @Input() public classColor: string;
    @Input() public primText: string;
    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    @Input() public secText: any[];
    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    @Input() public data: any;

    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @angular-eslint/no-output-on-prefix, @typescript-eslint/no-explicit-any
    @Output() public onClick: EventEmitter<any>;

    public dayName: string;

    constructor() {
        this.onClick = new EventEmitter();
    }

    ngOnInit() {
        moment.locale('sl');
        if (moment(this.dateTime).isSame(moment(), 'day')) {
            this.dayName = 'DANES';
        } else {
            this.dayName = moment(this.dateTime).format('ddd');
        }
    }

    public openReservation(): void {
        this.onClick.emit(this.data);
    }
}
